module.exports = __webpack_public_path__ + "img/logo_white.abc83d37.png";